/**
 * Property Form - Features Section
 */
import { useState } from "react";
import { Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const SUGGESTED_FEATURES = [
  "Piscina", "Jardín", "Terraza", "Garaje", "Seguridad 24/7",
  "Gimnasio", "Área de BBQ", "Vista Panorámica", "Ascensor",
  "Aire Acondicionado", "Cocina Equipada", "Área de Lavandería"
];

const PropertyFeatures = ({ features, setFeatures }) => {
  const [newFeature, setNewFeature] = useState("");

  const addFeature = (feature) => {
    const trimmed = feature.trim();
    if (trimmed && !features.includes(trimmed)) {
      setFeatures([...features, trimmed]);
    }
    setNewFeature("");
  };

  const removeFeature = (index) => {
    setFeatures(features.filter((_, i) => i !== index));
  };

  return (
    <section className="bg-[#121212] border border-white/5 p-6 space-y-6">
      <h2 className="text-lg text-white font-medium">Características</h2>
      
      {/* Current features */}
      <div className="flex flex-wrap gap-2">
        {features.map((feature, idx) => (
          <span 
            key={`feature-${idx}`}
            className="inline-flex items-center gap-1 bg-[#D4AF37]/10 text-[#D4AF37] px-3 py-1 rounded-full text-sm"
          >
            {feature}
            <button onClick={() => removeFeature(idx)} className="hover:text-red-400">
              <X size={14} />
            </button>
          </span>
        ))}
      </div>
      
      {/* Add new feature */}
      <div className="flex gap-2">
        <Input 
          value={newFeature}
          onChange={(e) => setNewFeature(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && (e.preventDefault(), addFeature(newFeature))}
          placeholder="Agregar característica..."
          className="h-10 bg-black/40 border-white/10 text-white flex-1"
        />
        <Button 
          type="button"
          onClick={() => addFeature(newFeature)}
          className="bg-[#D4AF37] text-black hover:bg-[#FFE082]"
        >
          <Plus size={16} />
        </Button>
      </div>
      
      {/* Suggested features */}
      <div>
        <p className="text-[#A3A3A3] text-sm mb-2">Sugerencias:</p>
        <div className="flex flex-wrap gap-2">
          {SUGGESTED_FEATURES.filter(f => !features.includes(f)).slice(0, 8).map(feature => (
            <button
              key={feature}
              type="button"
              onClick={() => addFeature(feature)}
              className="text-xs px-2 py-1 bg-white/5 text-[#A3A3A3] rounded hover:bg-white/10 hover:text-white transition-colors"
            >
              + {feature}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PropertyFeatures;
